<template>
  <div class="qrbox">
    <vue-qr class="qrimg" style="display: block;" colorDark="black" :text=qrSrc :dotScale='dot' :size="300"></vue-qr>
    <div class="btnlist">
      <Button  type="primary" shape="circle"  @click="saveQrImg">保存二维码</Button>
    </div>


  </div>
</template>
<script>
import VueQr from 'vue-qr'
export default {
  components:{
    "vue-qr":VueQr
  },
  props: [
    'qrSrc'
  ],
  data() {
    return {
      dot: 0.75,
      src: this.qrSrc,
    }
  },
  methods: {
    saveQrImg() {
      var qrCodeElement = document.querySelector('.qrimg')
      var url = qrCodeElement.src
      var alink = document.createElement("a");
      alink.href = url;
      var timestamp = Date.parse(new  Date());
      alink.download = "gobills_invite-"+ timestamp; //图片名
      alink.click();

    }
  }

}
</script>
<style scoped>
  .qrbox {
    width: 100%;
    margin: 0 auto;
  }

  .qrbox .qrimg {
    margin: 0 auto !important;
  }

  .btnlist {
    height: 160px;
    line-height: 160px;
    text-align: center;
  }
</style>

